/**
 * api接口的统一封装
 */
import {get,post} from './request.js';

function checkLogin(data){   //判断用户是否登录
    return get('/comic/isLogin',data)
}
function loginApi(data){   //登录
    return post('/comic/login',data)
}
function getcodeApi(data){   //获取短信验证码
    return post('/comic/sendLoginCode',data)
}
function loginOutApi(data){   //退出登录
    return get('/comic/logout',data)
}
function oauthQrcode(data){   //微信登录
    return get('/comic/oauth/qrcode',data)
}
function homeCarouselChart(data){   //首页轮播图
    return get('/comic/comic/carouselChart',data)
}
function homeList(data){   //首页数据
    return get('/comic/comic/homePage',data)
}
function homeRankList(data){   //首页排行榜
    return get('/comic/comic/charts',data)
}
function homeRecommend(data){   //首页排行榜
    return get('/comic/comic/recommend',data)
}
function useInfoApi(data){   //用户信息
    return get('/comic/user/info',data)
}
function homeComicCategory(data){   //首页分类列表
    return get('/comic/comic/allCategory',data)
}
function categoryGetList(data){   //分类页列表
    return get('/comic/comic/getPageList',data)
}
function searchApi(data){   //搜索
    return get('/comic/comic/search',data)
}
function comicuserChapterList(data){   //章节列表
    return get('/comic/comicuser/chapterList',data)
}
function comicuserComicDetail(data){   //漫画详情
    return get('/comic/comicuser/comicDetail',data)
}
function comicuserSingleLook(data){   //单章观看详情
    return get('/comic/comicuser/singleLook',data)
}
function comicuserAllChapter(data){   //当前漫画所有章节
    return get('/comic/comic/allChapter',data)
}
function enjoyReadPoint(data){   //收藏
    return get('/comic/enjoyRead/point',data)
}
function enjoyReadCancelPoint(data){   //取消收藏
    return get('/comic/enjoyRead/cancelPoint',data)
}
function likeReadPoint(data){   //点赞
    return get('/comic/likeRead/point',data)
}
function likeReadCancelPoint(data){   //取消点赞
    return get('/comic/likeRead/cancelPoint',data)
}
function gearGet(data){   //获取档位接口
    return get('/comic/pay/gear/get',data)
}
function comiCorderCreate(data){   //创建订单
    return post('/comic/order/create',data)
}
function orderFind(data){   //查询订单状态
    return get('/comic/order/find',data)
}
function rechargeFind(data){   //查询充值记录
    return get('/comic/recharge/find',data)
}
function rechargeRemain(data){   //查询用户余额
    return get('/comic/recharge/remain',data)
}
function marvelAi(data){   //漫展-智能ai
    return get('/comic/marvelExhibition/ai',data)
}
function marvelContribute(data){   //漫展-用户投稿
    return get('/comic/marvelExhibition/contribute',data)
}
function recentRead(data){   //观看历史
    return get('/comic/recentRead/getPageList',data)
}
function enjoyRead(data){   //收藏列表
    return get('/comic/enjoyRead/getPageList',data)
}
function unlockList(data){   //查询消费记录
    return get('/comic/unlockComic/unlockList',data)
}
function switchAutoSub(data){   //开启-关闭自动订阅
    return post('/comic/user/switchAutoSub',data)
}
function unlockChapter(data){   //解锁剧集
    return get('/comic/unlockComic/unlockChapter',data)
}

export {
    checkLogin,
    loginApi,
    getcodeApi,
    loginOutApi,
    oauthQrcode,
    homeCarouselChart,
    homeList,
    homeRankList,
    homeRecommend,
    useInfoApi,
    homeComicCategory,
    categoryGetList,
    searchApi,
    comicuserChapterList,
    comicuserComicDetail,
    comicuserSingleLook,
    comicuserAllChapter,
    enjoyReadPoint,
    enjoyReadCancelPoint,
    likeReadPoint,
    likeReadCancelPoint,
    gearGet,
    comiCorderCreate,
    orderFind,
    rechargeFind,
    rechargeRemain,
    marvelAi,
    marvelContribute,
    recentRead,
    enjoyRead,
    unlockList,
    switchAutoSub,
    unlockChapter,
}
